import React from "react";

const ConfigurationMap = props => {
  return (
    <div className="configuration-map">
      {props.children}
    </div>
  );
};

module.exports = ConfigurationMap;



// WEBPACK FOOTER //
// ./src/js/components/ConfigurationMap.js